<template>
  <b-row>
    <b-col md="3">
      <b-form-group label="Workshop">
        <b-select v-model="form.workshop">
          <option
            v-for="workshop in workshopList"
            :key="workshop"
            :value="workshop">
            {{ workshop }}
          </option>
        </b-select>
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group label="Date Service">
        <date-picker
          v-model="form.range"
          :shortcuts="false"
          format="YYYY-MM-DD"
          width="100%"
          range
          :disabled-time="true"
          lang="en" />
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group label="Common Item">
        <b-select
          v-model="form.commonItem"
          size="md">
          <option
            v-for="text in commonItemOptions"
            :key="text"
            :value="text">
            {{ text }}
          </option>
        </b-select>
      </b-form-group>
    </b-col>
    <b-col md="3">
      <div style="margin-top: 26px">
        <b-btn
          size="md"
          variant="primary"
          @click="handleSearch">
          Search
        </b-btn>
        <b-btn
          v-show="showReset"
          size="md"
          variant="secondary"
          class="ml-3"
          @click="handleReset">
          Reset
        </b-btn>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'

export default {
  name: 'SearchForm',
  components: {
    DatePicker,
    vSelect
  },
  data() {
    return {
      form: {
        workshop: undefined,
        range: [],
        commonItem: undefined
      },
      commonItemOptions: [
        'Spark Plug',
        'Aircon Filter',
        'Air Filter',
        'Transmission Fluid'
      ]
    }
  },
  computed: {
    ...mapState('workshop', ['workshopList']),
    showReset () {
      return this.form.workshop || this.form.range.length || this.form.commonItem
    }
  },
  created() {
    this.$store.dispatch('workshop/fetchWorkshops', { nameOnly: true })
  },
  methods: {
    handleSearch () {
      const newQuery = {}
      if (this.form.range.length > 0) {
        const start = moment(this.form.range[0]).format('YYYY-MM-DD')
        const end = moment(this.form.range[1]).format('YYYY-MM-DD')
        newQuery.dateService = [start, end]
      }
      if (this.form.workshop) {
        newQuery.workshop = this.form.workshop
      }
      if (this.form.commonItem) {
        newQuery.commonItem = this.form.commonItem
      }
      this.$emit('search', newQuery)
    },
    handleReset () {
      this.form.workshop = undefined
      this.form.commonItem = undefined
      this.form.range = []
      this.$emit('reset')
    }
  }
}
</script>

<style>

</style>